import styled from "styled-components";

export const FiltersContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;
  min-height: 50px;
  flex-wrap: wrap;
  gap: 16px;

  @media (max-width: 767px) {
    justify-content: flex-start;
    gap: 16px;
  }
`;

export const FiltersLeftContent = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  & > div:first-child {
    width: auto;
  }

  & > .department-filter > button > span, & > .owner-filter > button > span, & > .modified-filter > button > span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
    max-width: 120px;
  }
`;

export const FiltersRightContent = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  align-items: center;
`;

export const SearchContainer = styled.div`
  min-width: 200px;
`;

